
export interface IPosition {
    userPositionId: number;
    userPosition?: string | undefined;
    canHaveProviderCredentials?: boolean | undefined;
    isUserPositionEnabled?: boolean | undefined;
    
  }
  export class Position implements IPosition {
    userPositionId: number;
    userPosition?: string | undefined;
    canHaveProviderCredentials?: boolean | undefined;
    isUserPositionEnabled?: boolean | undefined;
    constructor(data?: IPosition) {
        if (data) {
          for (var property in data) {
            if (data.hasOwnProperty(property))
              (<any>this)[property] = (<any>data)[property];
          }
        }
      }
      init(_data?: any) {
        if (_data) {
          this.userPositionId = _data["userPositionId"];
          this.userPosition = _data["userPosition"];
          this.canHaveProviderCredentials = _data["canHaveProviderCredentials"];
          this.isUserPositionEnabled = _data["isUserPositionEnabled"];
        }
      }
      static fromJS(data: any): Position {
        data = typeof data === "object" ? data : {};
        let result = new Position();
        result.init(data);
        return result;
      }
      toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["userPositionId"] = this.userPositionId;
        data["userPosition"] = this.userPosition;
        data["canHaveProviderCredentials"] = this.canHaveProviderCredentials;
        data["isUserPositionEnabled"] = this.isUserPositionEnabled;
        return data;
        
      }
  }